import { Editor } from '@/proposals/editor/Editor';

/**
 * The proposal editor, mounted natively inside the admin shell. The
 * doc-generator editor is a full-height app (its own toolbar, page/layer panel,
 * canvas desk and inspector); the shell renders this route with `fillContent`,
 * so the editor simply fills the content column in flow — narrowing beside the
 * assistant when it opens — rather than floating over the frame.
 *
 * @returns The proposal editor filling the shell content area.
 */
export function ProposalEditorPage(): React.ReactElement {
  return (
    <div className="flex min-h-0 min-w-0 flex-1 bg-background">
      <Editor />
    </div>
  );
}
